import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { PlatformDataService } from '../../services/platform-data';
import { throwError } from 'rxjs';

export const serverErrorLoggerInterceptor: HttpInterceptorFn = (req, next) => {
  const platformDataService = inject(PlatformDataService);

  return next(req).pipe(
    catchError((error) => {
      if (platformDataService.isServer) {
        console.error('HTTP error on server:', error);
      }

      return throwError(() => error);
    })
  );
};
